import { OrderTypeCodesEnum } from '../order-management/order-type-codes.enum';

export interface CustomerPaymentTermsReq {
  countryCode: string;
  productLineId: string | number;
  jobsiteId: string | number;
  customerId: string | number;
  productId: number;
  contractCode?: string;
  commercialChannelCode?: OrderTypeCodesEnum;
}
